import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import Colors from "assets/Colors";
import { useTranslation } from "react-i18next";

function DocumentPDF({ data }) {
  const { t } = useTranslation();
  const {
    dateHeader,
    img1,
    header,
    customersWithMostPurchases,
    dataItemsMostBuys,
  } = data;
  return (
    <Document>
      <Page size="A4" style={styles.body} orientation="landscape">
        <View>
          <Text style={styles.date}>
            {t("containers.ReportsCustomers.reportsCustomerFor")}
            {dateHeader}
          </Text>

          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 10px 0px 10px",
              backgroundColor: "#f9f9f9",
              flexWrap: "wrap",
              gap: 20,
            }}
          >
            <Text style={styles.textIfo}>
              {t("containers.ReportsCustomers.newCustomers")}: {header.newUsers}
            </Text>
            <Text style={styles.textIfo}>
              {t("containers.ReportsCustomers.allCustomers")}:
              {header.totalUsers}
            </Text>
            <Text style={styles.textIfo}>
              {t("containers.ReportsCustomers.customerSales")}:
              {header.customerSales}
            </Text>
            <Text style={styles.textIfo}>
              {t("containers.ReportsCustomers.noCustomerSales")}:
              {header.notCustomerSales}
            </Text>
          </View>
        </View>

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 20,
            marginTop: 20,
          }}
        >
          <Image src={img1} style={{ width: "350px", objectFit: "contain" }} />

          <View>
            <View
              style={{
                // marginTop: 10,
                marginLeft: 10,
              }}
            >
              <Text style={styles.headerTable}>
                {t("containers.ReportsCustomers.customerWithMoreBuys")}
              </Text>
              <View
                style={[
                  styles.row,
                  styles.header,
                  {
                    fontSize: "8px",
                    backgroundColor: "#f9f9f9",
                  },
                ]}
              >
                <Text style={styles.row1}>
                  {t("containers.ReportsCustomers.client")}
                </Text>
                <Text style={styles.row2}>
                  {t("containers.ReportsCustomers.buyItems")}
                </Text>
                <Text style={styles.row3}>
                  {t("containers.ReportsCustomers.totalSales")}
                </Text>
              </View>
              {customersWithMostPurchases.map((row, i) => {
                const values = Object.values(row);
                return (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={styles.row1}>{values[0]}</Text>
                    <Text style={styles.row2}>{values[1]}</Text>
                    <Text style={styles.row3}>{values[2]}</Text>
                  </View>
                );
              })}
            </View>

            <View
              style={{
                marginTop: 20,
                marginLeft: 10,
              }}
            >
              <Text style={styles.headerTable}>
                {t("containers.ReportsCustomers.itemsMostBuys")}
              </Text>
              <View
                style={[
                  styles.row,
                  styles.header,
                  {
                    fontSize: "8px",
                    backgroundColor: "#f9f9f9",
                  },
                ]}
              >
                <Text style={[styles.row1, styles.with40]}>
                  {t("containers.ReportsCustomers.item")}
                </Text>
                <Text style={[styles.row2, styles.with20]}>
                  {t("containers.ReportsCustomers.itemPrice")}
                </Text>
                <Text style={[styles.row3, styles.with20]}>
                  {t("containers.ReportsCustomers.bought")}
                </Text>
                <Text style={[styles.row4, styles.with20]}>
                  {t("containers.ReportsCustomers.totalBought")}
                </Text>
              </View>
              {dataItemsMostBuys.map((row, i) => {
                const values = Object.values(row);
                return (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={[styles.row1, styles.with40]}>
                      {values[0]}
                    </Text>
                    <Text style={[styles.row2, styles.with20]}>
                      {values[1]}
                    </Text>
                    <Text style={[styles.row3, styles.with20]}>
                      {values[2]}
                    </Text>
                    <Text style={[styles.row4, styles.with20]}>
                      {values[3]}
                    </Text>
                  </View>
                );
              })}
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 20,
  },
  itemContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  divider: {
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.background_dividers,
    marginBottom: 15,
  },
  date: {
    fontSize: 8,
    fontWeight: 300,
    marginTop: -20,
    marginBottom: 20,
    textAlign: "right",
  },
  headerTable: {
    backgroundColor: Colors.BG_Header_Card,
    color: Colors.text_on_primary,
    fontSize: "8px",
    padding: 5,
    borderTopRightRadius: 2,
    borderTopLeftRadius: 2,
  },
  title: {
    fontSize: 8,
    fontWeight: 500,
    marginBottom: 5,
    textTransform: "capitalize",
  },
  textIfo: {
    fontSize: 8,
    fontWeight: 300,
    marginBottom: 10,
  },
  textIfoName: {
    fontSize: 8,
    fontWeight: 300,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    paddingTop: 8,
    paddingBottom: 8,
  },
  row1: {
    width: "33%",
    fontSize: 8,
    marginLeft: 5,
  },
  row2: {
    width: "33%",
    fontSize: 8,
    marginLeft: 5,
  },
  row3: {
    width: "33%",
    fontSize: 8,
    marginLeft: 5,
  },
  row4: {
    width: "33%",
    fontSize: 8,
    marginLeft: 5,
  },
  with40: {
    width: "40%",
  },
  with20: {
    width: "20%",
  },

  containerItems: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  containerPrices: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "70%",
  },
  mapItems: {
    width: "100%",
  },
  items: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
export default DocumentPDF;
